import { BrainCircuit, ChevronRight, ShieldCheck, Sparkles } from "lucide-react";
import { useState } from "react";
import { platformAdminSectionIds, type PlatformAdminSection } from "../lib/platform-admin";
import { useAuth } from "../lib/auth";
import { AiConnectionSettings } from "./SettingsPage";
import { SkillsAdminSection } from "./SkillsPage";
import { SystemUsersSection } from "./SystemUsersSection";

const sections = [
  { id: "ai", label: "Inteligência Artificial", icon: Sparkles },
  { id: "skills", label: "Skills", icon: BrainCircuit },
  { id: "users", label: "Usuários do Sistema", icon: ShieldCheck },
] as const;

export function PlatformAdminPage() {
  const { session } = useAuth();
  const [section, setSection] = useState<PlatformAdminSection>("ai");
  const sectionIds = platformAdminSectionIds(session?.platformRoles ?? []);
  const visibleSections = sections.filter(({ id }) => sectionIds.includes(id));
  const activeSection = sectionIds.includes(section) ? section : visibleSections[0]?.id;

  return (
    <div className="page platform-admin-page">
      <header className="page-header page-header--compact">
        <div>
          <span className="page-kicker">Plataforma · Administração</span>
          <h1>Admin</h1>
          <p>Gerencie a inteligência artificial, as skills e os usuários da plataforma.</p>
        </div>
      </header>
      <div className="settings-layout platform-admin-layout">
        <nav className="settings-nav" aria-label="Administração da plataforma">
          {visibleSections.map(({ id, label, icon: Icon }) => (
            <button key={id} className={activeSection === id ? "active" : ""} onClick={() => setSection(id)}>
              <Icon size={18} /><span>{label}</span><ChevronRight size={16} />
            </button>
          ))}
        </nav>
        <section className="settings-content platform-admin-content">
          {activeSection === "ai" && <AiConnectionSettings />}
          {activeSection === "skills" && <SkillsAdminSection />}
          {activeSection === "users" && sectionIds.includes("users") && <SystemUsersSection />}
        </section>
      </div>
    </div>
  );
}
